// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-list[data-v-3d42f6a0]{margin-bottom:20px;zoom:.5}@container (max-width : 500px){.title-list[data-v-3d42f6a0]{zoom:.55}}.title-list.full-width[data-v-3d42f6a0]{zoom:1;margin-bottom:0}@container (max-width : 500px){.title-list.full-width[data-v-3d42f6a0]{margin-bottom:20px}}.title-list.full-width[data-v-3d42f6a0] .hidden-horizontal-scrollbar__items{justify-content:space-between;min-width:calc(100% - 48px)}", ""]);
// Exports
module.exports = exports;
